var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return false &&
    !_vm.isAma &&
    _vm.credential &&
    _vm.credential.apiEncryptedUser &&
    _vm.retailPerc === 1
    ? _c(
        "a",
        { attrs: { href: "https://www.amadiamond.com/", target: "_blank" } },
        [
          _c("div", { staticClass: "ama-link" }, [
            _c("p", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.$t("discover_collection")))
            ]),
            _c("img", {
              staticClass: "img",
              attrs: { src: require("../assets/ama-link.png"), alt: "" }
            })
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }